import './ContactInfo.css';

const ContactInfo = () => {
  return (
    <aside className="contact-info">
      <div className="contact-info-section">
        <h3 className="contact-info-title">Get In Touch</h3>
        <p className="contact-info-description">
          We'd love to hear from you. Contact us for any queries or project
          discussions.
        </p>
      </div>

      <div className="contact-info-section">
        <div className="contact-info-item">
          <div className="contact-info-icon">
            <i className="bi bi-geo-alt-fill"></i>
          </div>
          <div className="contact-info-content">
            <h4>Headquarters</h4>
            <address>
              602, "Solaris Cube"
              <br />
              Besides Rajoo India
              <br />
              Behind Rahul Raj Mall, Vesu
              <br />
              Surat. 395 007.
            </address>
          </div>
        </div>

        <div className="contact-info-item">
          <div className="contact-info-icon">
            <i className="bi bi-telephone-fill"></i>
          </div>
          <div className="contact-info-content">
            <h4>Phone</h4>
            <a href="tel:+912617966893">(+91) 261 7966893</a>
          </div>
        </div>

        <div className="contact-info-item">
          <div className="contact-info-icon">
            <i className="bi bi-whatsapp"></i>
          </div>
          <div className="contact-info-content">
            <h4>WhatsApp</h4>
            <a
              href="https://wa.me/916355390141"
              target="_blank"
              rel="noopener noreferrer"
            >
              (+91) 6355390141
            </a>
          </div>
        </div>

        <div className="contact-info-item">
          <div className="contact-info-icon">
            <i className="bi bi-envelope-fill"></i>
          </div>
          <div className="contact-info-content">
            <h4>Email</h4>
            <a href="mailto:abhishektamakuwalaarchitects@gmail.com">
              abhishektamakuwalaarchitects@gmail.com
            </a>
          </div>
        </div>
      </div>

      <div className="contact-info-section">
        <h4 className="office-hours-title">Office Hours</h4>
        <div className="office-hours">
          <div className="office-hours-item">
            <span className="day">Monday - Saturday</span>
            <span className="time">10:30 AM - 6:30 PM</span>
          </div>
          {/* <div className="office-hours-item">
                        <span className="day">Saturday</span>
                        <span className="time">10:00 AM - 4:00 PM</span>
                    </div>*/}
          <div className="office-hours-item">
            <span className="day">Sunday</span>
            <span className="time">Closed</span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default ContactInfo;
